import {
  defineDirectory,
  DirectoryInstance,
} from 'best-modules/plugins/directory/directory'
import { DirectoryName } from './types'
import { months, yearsFrom2024, debtorReportDuplicateTypes } from './local'

const {
  DirectoryPlugin,
  fillDirectory,
  getDirectory,
  pushDirectoryItem,
  updateDirectoryItem,
  removeDirectoryItem,
  clearDirectory,
} = (() => {
  return defineDirectory<DirectoryName, never>({
    companyTypes: '/admin/list/companyTypes',
    companyList: '/admin/list/companies',
    months: { items: months },
    yearsFrom2024: { items: yearsFrom2024, indexedKey: 'year' },
    debtorReportDuplicateTypes: { items: debtorReportDuplicateTypes },
    caList: '/admin/electronicSignature/caList',
    packageStatuses: '/admin/list/reportPackageStatuses',
    userList: '/admin/list/users',
    companyUserList: '/admin/list/companyUsers',
    reportList: '/admin/list/reports',
    tariffTypes: '/admin/list/tariffs',
    signatureAlgos: '/admin/list/signatureAlgos',
    debtorTypes: '/admin/list/debtorTypes',
    checkReason: '/admin/list/debtorCheckReasons',
    debtorCredentials: '/admin/list/debtorCheckCredentials',
    nbuCreditTypes: '/admin/list/typeCredits',
    debtorCheckResult: '/admin/list/debtorCheckResults',
    extensionTariffs: '/admin/list/tariffExtensions',
  })
})()

export default DirectoryPlugin

export {
  fillDirectory,
  getDirectory,
  pushDirectoryItem,
  updateDirectoryItem,
  removeDirectoryItem,
  clearDirectory,
}

declare module '@vue/runtime-core' {
  export interface ComponentCustomProperties {
    $directory: DirectoryInstance<string>
  }
}
